<template>
    <el-dialog v-model="dialogShow" width="70%" center @close="closeEvent">
        <div v-html="info" style="max-height:70vh;overflow-y:auto;">
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, defineProps, defineEmits } from 'vue';
import { getPrivacy } from "@/api/common.js"
import { ElMessage } from 'element-plus'
const props = defineProps({
    popupShow: {
        type: Boolean,
        default: false
    }
})
const info = ref('')
const dialogShow = ref(props.popupShow)
const emitList = defineEmits(['close'])

function getInfo() {
    getPrivacy().then(res => {
        info.value = res.data.privacyContent;
    })
}
function closeEvent() {
    emitList('close')
}

onMounted(() => {
    getInfo()
})
</script>
<style lang="scss" scoped>

</style>

